<template>
  <div style="overflow-x: scroll">
    <v-container fluid grid-list-md style="padding: 8px">
      <v-btn
        absolute
        dark
        fab
        top
        right
        color="primary"
        style="top: 5px"
        @click="toAdd()"
        v-if="!isEditPackage"
      >
        <v-icon color="black">add</v-icon>
      </v-btn>
      <packageForm
        :dialog="packageDialog"
        @setDialog="packageDialog = $event"
        :editedIndex="editedIndex"
        @setEditIndex="editedIndex = $event"
        @cancelEdit="cancelEdit()"
        :form="form"
      />
      <v-layout row>
        <v-flex xs3>
          <v-card disabled>
            <span class="subheading font-weight-bold" style="text-align: center"
              >Name</span
            >
            <v-divider></v-divider>
            <v-list
              dense
              v-for="item in packageItems"
              :key="item.title"
              style="padding: 0"
            >
              <v-list-tile>
                <v-list-tile-content>{{ item.title }}</v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs10>
          <v-data-iterator
            :items="package_list"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            content-tag="v-layout"
            row
            wrap
          >
            <v-flex slot="item" slot-scope="props">
              <v-card disabled>
                <span class="subheading font-weight-bold">{{
                  props.item.package_name
                }}</span>
                <!-- <div class="package-btn">
                  <v-tooltip top>
                    <v-btn icon small slot="activator" class="edit-btn">
                    <v-icon small
                    @click="editPackage(props.item,props.index)">edit</v-icon>
                    </v-btn>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn icon small slot="activator" class="delete-btn">
                    <v-icon small 
                    @click="delPackage(props.item)">delete</v-icon>
                    </v-btn>
                    <span>Delete</span>
                  </v-tooltip>
                </div>-->

                <v-divider></v-divider>

                <v-list dense style="padding: 0">
                  <v-list-tile>
                    <v-list-tile-content class="align-center">
                      <v-flex>
                        <v-btn
                          small
                          icon
                          color="primary"
                          class="black--text"
                          @click="editPackage(props.item, props.index)"
                          v-if="!isEditPackage"
                        >
                          <v-icon small>edit</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          icon
                          color="red"
                          @click="delPackage(props.item)"
                          v-if="!isEditPackage"
                        >
                          <v-icon small>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">
                      {{
                        props.item.package_payment_method == 1
                          ? "Auto transfer"
                          : props.item.package_payment_method == 2
                          ? "Pay at store"
                          : "Pay at store (Partner)"
                      }}
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      "฿ " + props.item.package_extra_transport_price
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_commission
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      props.item.package_withdrawal_max
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_fee_withdrawal
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      props.item.package_money_to_system
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_fee_credit_card
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      props.item.package_withdrawal_date
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_area_delivery
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      props.item.package_monthly_shop_promotion
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_promotion_from_weserve
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      props.item.package_item_recommended
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_item_bestseller
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      props.item.package_standard_shop_system == 0
                        ? "None"
                        : "Yes"
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_review_rate == 0 ? "None" : "Yes"
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      props.item.package_blog == 0
                        ? "None"
                        : props.item.package_blog
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_online_marketing == 0
                        ? "None"
                        : props.item.package_online_marketing
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content class="align-center">{{
                      props.item.package_food_photo == 0 ? "None" : "Yes"
                    }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile class="gray-color">
                    <v-list-tile-content class="align-center">{{
                      props.item.package_monthly_fee
                    }}</v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-data-iterator>
        </v-flex>
      </v-layout>

      <!-- <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages" v-if="pagination.rowsPerPage > 5"></v-pagination>
      </div>-->
    </v-container>
  </div>
</template>
<script>
import packageForm from "./PackageForm.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    packageForm,
  },
  data: () => ({
    form: null,
    dialog: false,
    editedIndex: -1,
    packageDialog: "",
    rowsPerPageItems: [4, 5, 6],
    pagination: {
      rowsPerPage: 5,
      page: 1,
      totalItems: 0,
    },
    original_data: null,
    packageItems: [
      { title: "" },
      { title: "Cash flow method" },
      { title: "Extra transport price" },
      { title: "Commission" },
      { title: "Withdrawal-max" },
      { title: "Fee Withdrawal" },
      { title: "Money into system" },
      { title: "Fee credit card" },
      { title: "Withdrawal Date" },
      { title: "Area Delivery" },
      { title: "Shop Promotion" },
      { title: "Promotion from WESERVE" },
      { title: "Recommended Product Features" },
      { title: "Popular Product Features" },
      { title: "Standard Shop System" },
      { title: "Review Rate" },
      { title: "Blog Editors from WESERVE" },
      { title: "Online Marketing (FB or IG)" },
      { title: "Food Photo" },
      { title: "Monthly Fee" },
    ],
  }),
  computed: {
    ...mapState({
      package_list: (state) => state.fetchPackageBack.package_list,
    }),
    ...mapGetters({
      isEditPackage: "isEditPackage",
    }),
  },
  methods: {
    cancelEdit() {
      Object.assign(this.form, this.original_data);
    },
    async toAdd() {
      await this.setForm();
      this.packageDialog = true;
    },
    setForm() {
      this.form = {
        package_payment_method: 1,
        package_area_delivery: "ภูเก็ต",
        package_blog: 0,
        package_commission: 10,
        package_description: null,
        package_fee_credit_card: "4.00",
        package_fee_withdrawal: 0,
        package_food_photo: 0,
        package_id: null,
        package_item_bestseller: 0,
        package_item_recommended: 0,
        package_money_to_system: 15,
        package_monthly_fee: 0,
        package_monthly_shop_promotion: 0,
        package_name: "123123123",
        package_online_marketing: 0,
        package_pay_cash_date: null,
        package_pay_online_fee_date: null,
        package_pay_wepay_fee_date: null,
        package_promotion_from_weserve: 0,
        package_review_rate: 1,
        package_standard_shop_system: 1,
        package_withdrawal_date: "+5 วัน",
        package_withdrawal_max: 100000,
        package_extra_transport_price: 0,
      };
    },
    async editPackage(item, index) {
      this.original_data = Object.assign({}, item);
      this.form = item;
      this.packageDialog = true;
      this.editedIndex = index;
    },
    delPackage(item) {
      if (confirm("Are you sure you want to delete this package?")) {
        this.$store.dispatch("fetchPackageBack/delPackage", {
          item,
          province: this.$route.params.province,
        });
      }
    },
  },
  async created() {
    // this.$store.commit('backOffice/changeLoadingProgress',true)
    await this.$store.dispatch("fetchPackageBack/getPackageList", {
      province_name: this.$route.params.province,
    });
    this.$store.commit("backOffice/changeLoadingProgress", false);
  },
};
</script>

<style scoped>
.gray-color {
  background-color: #eeeeee;
}
.package-btn {
  position: relative;
  top: -22px;
  right: -15px;
}

.edit-btn {
  position: absolute;
  left: 50px;
  top: -10px;
}

.delete-btn {
  position: absolute;
  left: 75px;
  top: -10px;
}

@media screen and (max-width: 1220px) {
  .package-btn {
    right: -2px;
  }
}

@media screen and (max-width: 1076px) {
  .package-btn {
    right: 20px;
  }
}

@media screen and (max-width: 615px) {
  .package-btn {
    right: 40px;
  }
}

@media screen and (max-width: 375px) {
  .package-btn {
    right: 95px;
  }
  .delete-btn {
    left: 100px;
  }
}
</style>
